import React from 'react';
import { motion } from 'framer-motion';

import type { DealSelectorProps } from '../OptionSelector';

import classes from './DealRibbonSlim.module.scss';

function DealRibbonSlim({
    deals,
    noDealOption,
    onSelectDeal,
    onClearDeal,
}: DealSelectorProps) {
    const visibleDeals = deals.slice(0, 2);

    if (visibleDeals.length === 0) {
        return null;
    }

    return (
        <div className={classes.ribbon}>
            {visibleDeals.map((dealOption) => (
                <motion.button
                    type="button"
                    key={dealOption.deal._id}
                    className={`${classes.card} ${dealOption.isActive ? classes.active : ''}`}
                    whileTap={{ scale: 0.97 }}
                    transition={{ duration: 0.15 }}
                    onClick={() => (dealOption.isActive && noDealOption.show ? onClearDeal() : onSelectDeal(dealOption.deal._id))}
                >
                    <span className={classes.title}>{dealOption.deal.title}</span>
                </motion.button>
            ))}
        </div>
    );
}

export default DealRibbonSlim;
